import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TableHeaderService} from '../../../../resources/services/table-header.service';
import {StoreAppService} from '../../../../resources/services/store-app.service';

@Component({
  selector: 'store-view-info',
  templateUrl: './store-view-info.component.html'
})
export class StoreViewInfoComponent implements OnInit {

  id: any = this.route.parent.snapshot.params.id;
  item: any;

  constructor(private tableHeaderService: TableHeaderService,
              private route: ActivatedRoute,
              private modelService: StoreAppService) {
  }

  ngOnInit(): void {
    this.get();
  }

  get(): void {
    this.modelService.get({
      id: this.id,
      relations: []
    })
      .subscribe((res: any) => {
          this.item = res;
        },
        err => {
        }
      );
  }

  duplicate(): void {
    this.modelService.duplicate({
      id: this.id
    })
      .subscribe((res: any) => {
          // this.item = res;
        },
        err => {
        }
      );
  }

}
